<template>
    <section class="quiz__campaign-question" :class="{ 'quiz__campaign-question-active' : active_question }">
        <div class="quiz__campaign-question-block">
            <div class="quiz__campaign-question-mobile-fallback"  :style="backgroundImage"></div>
            <img v-if="question.desktop_media_id" :src="question.desktop_media" />
            <p class="quiz__campaign-question-text">
                <small class="quiz__campaign-question-number">{{ currentQuestionNumber }}<br></small>
                {{ question.content }}
            </p>
        </div>
        <div class="quiz__campaign_range-answers">
            <div class="quiz__campaign-range-images">
                <range-picture v-if="range_answer == pic_key" v-for="(answer_pic, pic_key) in question.answers" :answer="answer_pic" :key="'picture_' + pic_key"></range-picture>
            </div>
            <div class="quiz__campaign-range-area">
                <input type="range" min="0" :max="rangeMaxAmount" step="1" name="range" v-model="value" @change="rangeChange" />
            </div>
            <label for="range" class="quiz__campaign-question-range-labels">
                <range-answer v-for="(answer, key) in question.answers" :question="question.id" :answers="question.answers" :answer="answer" :answer_given="answer_given" :key="'answer_'+key"></range-answer>
            </label>
        </div>
    </section>
</template>
<script>
import RangeAnswer from './range-answer';
import RangePicture from './range-picture';
export default {
    props: ['question','index','questionsinpage','quizactive', 'question_number'],
    components: {
        RangeAnswer,
        RangePicture
    },
    computed: {
        registerInRoute: function()
        {
            return ((this.questionsinpage == 1 && (this.question.quiz_campaign_question_type_id == 4 || this.question.quiz_campaign_question_type_id == 1 || this.question.quiz_campaign_question_type_id == 2)) || this.question.is_last_question === true || this.lastOnPage === true);
        },
        backgroundImage: function() {
            return '';
        },
        currentQuestionNumber: function() {
            return String(this.questionNumber).padStart(2,0);
        },
        rangeAnswerGiven: function()
        {
            return this.question.answers[this.range_answer];
        },
        answersAmount: function(){
            return 1;
        },
        rangeMaxAmount: function(){
            return this.question.answers.length - 1;
        },
        lastOnPage: function()
        {
            return ((this.index + 1) == this.questionsinpage);
        }
    },
    methods : {
        rangeChange()
        {
            this.range_answer = this.value;
            Event.$emit('page_answer_given', { question_id: this.question.id, question_type: this.question.quiz_campaign_question_type_id, answer_id: this.rangeAnswerGiven.id });
        },
        updateQuestionVisibility( question = null )
        {
            Event.$emit('question_moving', { next_question : question.id });
        },
        getNextQuestion( question, answer ) {
            $.ajax('/quiz-campaign/next/'+ question + '/' + answer, {
                method: 'GET',
                success: function(response, textStatus, xhr) {
                    this.next_question = response;
                },
                error: function(xhr, textStatus, string){
                    console.log(string);
                }
            });
        }
    },
    created() {
        Event.$emit('page_answer_given', { question_id: this.question.id, answer_id: this.rangeAnswerGiven.id });
        Event.$on('question_'+ this.question.id +'_answered', ($event) => (this.answer_given = true) );
        Event.$on('question_'+ this.question.id +'_answered', ($event) => ( this.getNextQuestion( this.question.id, $event.active_id ) ) );
        Event.$on('question_moving', ($event) => ( this.active_question = (this.question.id == $event.next_question ) ? true : false ));
    },
    mounted (){
        if( this.registerInRoute === true )
        {
            Event.$emit('build_endpoint_key', { question_id: this.question.id });
        }
    },
    data() {
        return {
            value: 0,
            answer_given: true,
            active_question: true,
            next_question: null,
            range_answer: 0,
            answered: null,
            is_visible: false,
            questionNumber: this.question_number
        }
    }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/quiz-campaign/components/range.vue